import { Alert, Box } from "@mui/material";

export const PlanErrorBoundaryFallback = () => (
  <Box>
    <Alert severity="error">
      Something went wrong. We can&apos;t display coverage plan information.
    </Alert>
  </Box>
);
